import React, { useEffect, useRef, useState } from "react";
import Footer from "../../components/Home/Footer";
import emailjs from "@emailjs/browser";

function FooterContainer() {
  const formRef = useRef();
  const [isErrors, setIsErrors] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ status: null, message: "" });

  const handleSubscribe = (e) => {
    e.preventDefault();
    console.log(formRef.current, "formRef.current");

    const emailInput = formRef.current?.querySelector("input[name='email']");
    const emailValue = emailInput?.value.trim();
    setIsLoading(true);

    if (!emailValue) {
      setIsErrors(true);
      setIsLoading(false);
      return;
    }

    emailjs
      .sendForm(
        "service_gq7irar",
        "template_fx0djbp",
        formRef.current, // form element
        "WC-QhzT5C1RaJDCos"
      )
      .then(
        (result) => {
          emailInput.value = "";
          setIsErrors(false);
          setIsLoading(false);
          setMessage({
            status: true,
            message: "email sent successfully.",
          });
        },
        (error) => {
          setIsErrors(false);
          setIsLoading(false);
          setMessage({
            status: true,
            message: "error reported.",
          });
        }
      );
  };

  useEffect(() => {
    setMessage({ status: null, message: "" });
  }, []);

  return (
    <Footer
      handleSubmit={handleSubscribe}
      formRef={formRef}
      isLoading={isLoading}
      message={message}
      isErrors={isErrors}
    />
  );
}

export default FooterContainer;
